import { useState } from "react";
import { useAuth0 } from "@auth0/auth0-react";
import axios from "../../utils/axiosConfig";

export default function AccountLink() {
  const { loginWithRedirect } = useAuth0();
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState("");

  const handleLinkAccount = async () => {
    try {
      setLoading(true);
      setMessage("");

      // Jesteśmy jeszcze zalogowani przez Google.
      // Backend zapisze google-oauth2|... jako secondary identity.
      const response = await axios.post("/account-link/start");

      const linkId = response.data.linkId;

      sessionStorage.setItem("accountLinkId", linkId);

      // Teraz wymuszamy logowanie starym kontem email + hasło.
      await loginWithRedirect({
        appState: {
          returnTo: "/account-link/complete",
        },
        authorizationParams: {
          audience: "https://someet-api",
          connection: "Username-Password-Authentication",
          prompt: "login",
        },
      });
    } catch (err) {
      console.error("Account linking start failed:", err);

      setMessage(
        err?.response?.data?.message ||
          "Nie udało się rozpocząć łączenia kont."
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <section className="auth-page">
      <div className="auth-container">
        <h2>Masz już konto</h2>

        <p>
          Ten adres e-mail jest już używany w Someet.
          Zaloguj się dotychczasowym hasłem, aby połączyć konto z Google.
        </p>

        <button onClick={handleLinkAccount} disabled={loading}>
          {loading ? "Przekierowanie…" : "Połącz konto"}
        </button>

        {message && <p>{message}</p>}
      </div>
    </section>
  );
}